const ContactView = () => import("@views/user-center-contact/user-center-contact-view.vue");

export const contactRoutes = [
    {
        component: ContactView,
        name: "contact_home",
        path: "contact",
    },
];